import Vue from 'vue'
import VueRouter from 'vue-router'
import CONFIG from '../config'

Vue.use(VueRouter)

const router = new VueRouter()

router.map({
  '/login': {
    component: resolve => require(['../views/Login.vue'], resolve),
    auth: false
  },
  '/s-login': {
    component: resolve => require(['../views/StudentLogin.vue'], resolve),
    auth: false
  },
  '/s-info': {
    component: resolve => require(['../views/StudentInfo.vue'], resolve),
    auth: true
  },
  '/': { // 项目首页
    component: resolve => require(['../views/Student.vue'], resolve),
    auth: true
  },
  '/user': { // 用户页面
    component: resolve => require(['../views/User.vue'], resolve),
    auth: true
  },
  '/user/:id': { // 用户信息
    component: resolve => require(['../views/UserAdd.vue'], resolve),
    auth: true
  },
  '/teacher': { // 教员管理
    component: resolve => require(['../views/Teacher.vue'], resolve),
    auth: true
  },
  '/teacher/:id': { // 教员信息
    component: resolve => require(['../views/TeacherDetail.vue'], resolve),
    auth: true
  },
  '/student': { // 学员管理
    component: resolve => require(['../views/Student.vue'], resolve),
    auth: true
  },
  '/student/:id': { // 学员信息   :id -> add/:id
    component: resolve => require(['../views/StudentDetail.vue'], resolve),
    auth: true
  },
  '/class': { // 班次管理
    component: resolve => require(['../views/Class.vue'], resolve),
    auth: true
  },
  '/class/:id': { // 班次信息   :id -> add/:id
    component: resolve => require(['../views/ClassDetail.vue'], resolve),
    auth: true
  },
  '/class/:id/record/add': { // 班次信息 添加培训记录
    component: resolve => require(['../views/ClassAddRecord.vue'], resolve),
    auth: true
  },
  '/class/:id/record/:studentId': { // 班次信息 查看学生培训记录
    component: resolve => require(['../views/ClassEditStudentRecord.vue'], resolve),
    auth: true
  },
  '/class/:id/result/add': { // 班次信息 添加结课成绩
    component: resolve => require(['../views/ClassAddResult.vue'], resolve),
    auth: true
  },
  '/class/:id/result/:studentId': { // 班次信息 编辑学生结课成绩
    component: resolve => require(['../views/ClassEditStudentResult.vue'], resolve),
    auth: true
  },
  '/class/:id/cert/add': { // 班次信息 查看颁证信息
    component: resolve => require(['../views/ClassAddCert.vue'], resolve),
    auth: true
  },
  '/class/:id/cert/:studentId': { // 班次信息 编辑学员颁证信息
    component: resolve => require(['../views/ClassEditStudentCert.vue'], resolve),
    auth: true
  },
  '/class/:id/student/add': { // 班次信息 添加学员
    component: resolve => require(['../views/ClassStudentAdd.vue'], resolve),
    auth: true
  },
  '/doc': { // 手册管理
    component: resolve => require(['../views/Doc.vue'], resolve),
    auth: true
  },
  '/doc/:id': { // 手册信息   :id -> add/:id
    component: resolve => require(['../views/DocDetail.vue'], resolve),
    auth: true
  },
  '/course': { // 课程管理
    component: resolve => require(['../views/Course.vue'], resolve),
    auth: true
  },
  '/course/:id/': { // 课程管理
    component: resolve => require(['../views/CourseDetail.vue'], resolve),
    auth: true
  },
  '/course/:id/chapter/:chapterId': { // 章节管理
    component: resolve => require(['../views/ChapterDetail.vue'], resolve),
    auth: true
  },
  '/plane': { // 飞机管理
    component: resolve => require(['../views/Plane.vue'], resolve),
    auth: true
  },
  '/plane/add': { // 飞机添加
    component: resolve => require(['../views/PlaneAdd.vue'], resolve),
    auth: true
  },
  '/plane/:id': { // 飞机信息   :id -> add/:id
    component: resolve => require(['../views/PlaneDetail.vue'], resolve),
    auth: true
  },
  '/practice': { // 实训管理
    component: resolve => require(['../views/Practice.vue'], resolve),
    auth: true
  },
  '/practice/add': { // 实训管理
    component: resolve => require(['../views/PracticeDetail.vue'], resolve),
    auth: true
  },
  '/practice/:id': { // 实训管理
    component: resolve => require(['../views/PracticeDetail.vue'], resolve),
    auth: true
  },
  '/practiceManager/:id': { // 实训界面
    component: resolve => require(['../views/practiceManager.vue'], resolve),
    auth: true
  },
  '3d': {
    component: resolve => require(['../views/3d.vue'], resolve),
    auth: true
  }
})

/*
* localStorage存储的数据
*
* 用户id：topxgun_training_userId
* token：topxgun_training_token
* 用户角色：topxgun_training_account
*
* */
router.beforeEach((transition) => {
  if (transition.to.auth) {
    const storage = window.localStorage
    if (storage && (storage.topxgun_training_token && storage.topxgun_training_userId && storage.topxgun_training_userRole) || (storage.topxgun_training_studentRole && storage.topxgun_training_studentToken && storage.topxgun_training_studentId)) {
      if (storage.topxgun_training_token && storage.topxgun_training_userId) {
        Vue.http.headers.common['token'] = window.localStorage.topxgun_training_token
        Vue.http.headers.common['user_id'] = window.localStorage.topxgun_training_userId
        Vue.http.post(CONFIG.API_URL + '/user/login').then(res => {
          if (res.data.code === 0) {
            if (window.localStorage.topxgun_training_userRole === '3' && transition.to.path === '/user') {
              transition.redirect({ path: '/login' })
            } else {
              transition.next()
            }
          } else {
            Vue.http.headers.common['token'] = ''
            Vue.http.headers.common['user_id'] = ''
            transition.redirect({ path: '/login' })
          }
        })
      } else {
        Vue.http.headers.common['token'] = window.localStorage.topxgun_training_studentToken
        Vue.http.headers.common['user_id'] = window.localStorage.topxgun_training_studentId
        Vue.http.post(CONFIG.API_URL + '/student/login').then(res => {
          if (res.data.code === 0) {
            if (transition.to.path === '/s-info') {
              transition.next()
            } else if (transition.to.path === '/') {
              transition.redirect({ path: '/s-info' })
            } else {
              transition.redirect({ path: '/s-login' })
            }
          } else {
            Vue.http.headers.common['token'] = ''
            Vue.http.headers.common['user_id'] = ''
            transition.redirect({ path: '/s-login' })
          }
        })
      }
    } else {
      Vue.http.headers.common['token'] = ''
      Vue.http.headers.common['user_id'] = ''
      transition.redirect({ path: '/login' })
    }
  } else {
    Vue.http.headers.common['token'] = ''
    Vue.http.headers.common['user_id'] = ''
    transition.next()
  }
  // transition.next()
})

export default router



/** WEBPACK FOOTER **
 ** ./src/libs/router.js
 **/